import { Button, Divider, MenuItem, Select, Switch, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import StockCard from "components/ui/StockCard";
import addUsp from "assets/setting/addusp.png";
import toggleImage from "assets/setting/toggleImage.png";
import { useEffect, useRef, useState } from "react";
import uploadIcon from "assets/setting/uploadIcon.svg";
import MediaUploadModal from "./MediaUploadModal";
import DeleteIcon from "assets/setting/DeleteIcon.png";
import PreviewVideo from "./PreviewVideo";
import { useNavigate } from "react-router-dom";
import USPCard from "./USPCard";
import MediaSelect from "./MediaSelect";

const AddUSPDetails = () => {
  const [textAreaInput, setTextAreaInput] = useState("");
  const [uspMessage, setUspMessage] = useState("");

  const navigate = useNavigate();
  const [showToggleImage, setShowToggleImage] = useState(true);
  const [selectValue, setSelectValue] = useState("");
  const [openImageModal, setOpenImageModal] = useState(false);
  const [openVideoModal, setOpenVideoModal] = useState(false);

  const [uploadedImages, setUploadedImages] = useState([]);
  const [modalImages, setModalImages] = useState([]);
  const [modalVideos, setModalVideos] = useState([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [uploadedVideos, setUploadedVideos] = useState([]);
  const [videoURLs, setVideoURLs] = useState([]);
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(0);
  const [dragImageIndex, setDragImageIndex] = useState(null);

  const handleImageDrop = (index) => {
    if (dragImageIndex === null || dragImageIndex === index) return;
    const reordered = [...uploadedImages];
    const [movedImage] = reordered.splice(dragImageIndex, 1);
    reordered.splice(index, 0, movedImage);
    setUploadedImages(reordered);
    setDragImageIndex(null);
  };

  useEffect(() => {
    // Clean up old URLs
    videoURLs.forEach((url) => URL.revokeObjectURL(url));
    // Create new URLs
    const urls = uploadedVideos.map((file) => URL.createObjectURL(file));
    setVideoURLs(urls);
    // Cleanup on unmount
    return () => {
      urls.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [uploadedVideos]);

  const handleOpenImageModal = () => {
    setModalImages(uploadedImages);
    setOpenImageModal(true);
  };

  const handleSaveImages = () => {
    setUploadedImages(modalImages);
    setOpenImageModal(false);
  };

  const handleOpenVideoModal = () => {
    setModalVideos(uploadedVideos);
    setOpenVideoModal(true);
  };

  const handleSaveVideos = () => {
    setUploadedVideos(modalVideos);
    setOpenVideoModal(false);
  };

  const handleToggleChange = () => {
    setShowToggleImage(!showToggleImage);
  };
  const handleSelectChange = (e) => {
    const value = e.target.value;
    setSelectValue(value);
    if (value === "add image") {
      handleOpenImageModal();
      setSelectValue("");
    }
    if (value === "add video") {
      handleOpenVideoModal();
      setSelectValue("");
    }
  };

  useEffect(() => {
    setSelectValue("");
  }, []);

  return (
    <Box sx={{ paddingLeft: "32px", minHeight: "100vh" }}>
      <Divider orientation="horizontal" flexItem style={{ borderColor: "#444444", width: "100%", marginRight: "-20px" }} />
      {/* Main Container */}
      <Box sx={{ display: "flex", flexDirection: "row", width: "100%", minHeight: "100vh" }}>
        {/* left Continer */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Box sx={{ marginBottom: "28px", marginTop: "32px", marginRight: "32px", width: "956px", height: "42px", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <h2 style={{ fontFamily: "Poppins", fontSize: "18px", lineHeight: "36px", fontWeight: 500 }}>Add USP & Gallery</h2>
            <Box>
              <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "216px", height: "42px" }}>
                <button
                  style={{
                    border: "1px solid #50C878",
                    color: "#50C878",
                    width: "168px",
                    height: "42px",
                    borderRadius: "5px",
                    fontFamily: "Poppins",
                    fontSize: "18px",
                    fontWeight: 500,
                    lineHeight: "22px",
                    letterSpacing: "-0.41px",
                    textTransform: "none",
                    background: "transparent",
                    cursor: "pointer",
                  }}
                >
                  Save Changes
                </button>
                <IconButton
                  sx={{ width: "32px", height: "32px", border: "1px solid #8B8B8B", borderRadius: "4px" }}
                  aria-label="close"
                  onClick={() => window.close() || navigate("/product-usp-and-gallery")}
                >
                  <CloseIcon sx={{ width: "16px", height: "16px", color: "#8B8B8B" }} />
                </IconButton>
              </Box>
            </Box>
          </Box>

          <Box sx={{ display: "flex", paddingRight: "32px", gap: "24px" }}>
            <Box>
              <USPCard />
            </Box>
            <Box sx={{ width: "477px", height: "230px", display: "flex", flexDirection: "column", gap: "16px" }}>
              <Box sx={{ display: "flex", width: "100%", height: "28px", justifyContent: "space-between", alignItems: "center" }}>
                <h5 style={{ fontSize: "16px", fontFamily: "Poppins", fontWeight: 500 }}>Product USP</h5>
                <button
                  style={{
                    backgroundColor: "#3D3D3D",
                    border: "none",
                    color: "#8E8E93",
                    width: "83px",
                    height: "28px",
                    borderRadius: "5px",
                    padding: "10px",
                    fontSize: "12px",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => setUspMessage(textAreaInput)}
                >
                  Save USP
                </button>
              </Box>
              <TextField
                variant="outlined"
                placeholder="Enter USP message..."
                sx={{
                  width: "477px",
                  height: "185px",
                  "& .MuiOutlinedInput-root": {
                    height: "100%",
                    alignItems: "flex-start",
                    borderRadius: "4px", // optional
                    "& fieldset": {
                      border: "1px solid #8080808C", // always visible border
                    },
                    "&:hover fieldset": {
                      border: "1px solid #8080808C", // no change on hover
                    },
                    "&.Mui-focused fieldset": {
                      border: "1px solid #8080808C", // no change on focus
                    },
                    "&.Mui-focused": {
                      boxShadow: "none", // remove glow effect
                    },
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #8080808C", // ensure consistency
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #8080808C",
                  },
                  "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #8080808C",
                  },
                }}
                value={textAreaInput}
                onChange={(e) => setTextAreaInput(e.target.value)}
              />
            </Box>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", paddingRight: "32px", marginTop: "32px", alignItems: "center", mb: 2 }}>
            <Box>
              <h5
                style={{
                  fontSize: "18px",
                  fontWeight: 500,
                  fontFamily: "Poppins",
                  margin: 0,
                  padding: 0,
                }}
              >
                Product Gallery
              </h5>
              <p style={{ color: "#8B8B8B", margin: 0, fontSize: "14px" }}>
                {(uploadedVideos.length > 0 || uploadedImages.length > 0) && (
                  <>
                    ({uploadedVideos.length > 0 && `${uploadedVideos.length} Video${uploadedVideos.length > 1 ? "s" : ""}`}
                    {uploadedVideos.length > 0 && uploadedImages.length > 0 && " & "}
                    {uploadedImages.length > 0 && `${uploadedImages.length} Image${uploadedImages.length > 1 ? "s" : ""}`})
                  </>
                )}
              </p>
            </Box>
            <MediaSelect handleSelectChange={handleSelectChange} selectValue={selectValue} from={"Add"} />
          </Box>

          {uploadedImages.length === 0 && uploadedVideos.length === 0 && (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <img src={addUsp} width={"225px"} height={"165px"} />
            </Box>
          )}

          <Box>
            <Box>
              {/* Display uploaded videos (no drag) */}
              {uploadedVideos.map((file, idx) => (
                <Box
                  key={`video-${idx}`}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                    mr: 4,
                    py: 1,
                    borderBottom: "1px solid #444444",
                  }}
                >
                  <video
                    src={videoURLs[idx]}
                    width={120}
                    height={80}
                    style={{
                      borderRadius: 8,
                      objectFit: "cover",
                      border: "1px solid #ccc",
                      marginRight: 12,
                    }}
                  />
                  <span style={{ color: "#fff", flex: 1, marginRight: 12 }}>{file.name}</span>
                  <IconButton
                    onClick={() => {
                      const updated = [...uploadedVideos];
                      const updatedURLs = [...videoURLs];
                      updated.splice(idx, 1);
                      updatedURLs.splice(idx, 1);
                      setUploadedVideos(updated);
                      setVideoURLs(updatedURLs);
                    }}
                    size="small"
                    sx={{ color: "#f44336" }}
                  >
                    <img src={DeleteIcon} width="22px" height="22px" />
                  </IconButton>
                </Box>
              ))}

              {/* Display uploaded images (draggable via 6-dot handle) */}
              {uploadedImages.map((file, idx) => (
                <Box
                  key={`image-${idx}`}
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={() => handleImageDrop(idx)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                    mr: 4,
                    py: 1,
                    borderBottom: "1px solid #444444",
                  }}
                >
                  {/* Drag handle (6-dot icon) */}
                  <span
                    draggable
                    onDragStart={() => setDragImageIndex(idx)}
                    style={{
                      marginRight: 12,
                      display: "flex",
                      alignItems: "center",
                      cursor: "grab",
                    }}
                  >
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="#8B8B8B">
                      <circle cx="4" cy="4" r="1.5" />
                      <circle cx="4" cy="9" r="1.5" />
                      <circle cx="4" cy="14" r="1.5" />
                      <circle cx="10" cy="4" r="1.5" />
                      <circle cx="10" cy="9" r="1.5" />
                      <circle cx="10" cy="14" r="1.5" />
                    </svg>
                  </span>

                  {/* Image preview */}
                  <img
                    src={URL.createObjectURL(file)}
                    alt={`uploaded-img-${idx}`}
                    width={80}
                    height={80}
                    style={{
                      borderRadius: 8,
                      objectFit: "cover",
                      border: "1px solid #ccc",
                      marginRight: 12,
                    }}
                  />

                  {/* File name */}
                  <span style={{ color: "#fff", flex: 1, marginRight: 12 }}>{file.name}</span>

                  {/* Delete button */}
                  <IconButton
                    onClick={() => {
                      const updated = [...uploadedImages];
                      updated.splice(idx, 1);
                      setUploadedImages(updated);
                    }}
                    size="small"
                    sx={{ color: "#f44336" }}
                  >
                    <img src={DeleteIcon} width="22px" height="22px" />
                  </IconButton>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
        <Divider orientation="vertical" flexItem sx={{ borderColor: "#101010", borderRightWidth: 5, mx: 0, alignSelf: "stretch" }} />
        {/* right Container */}
        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
          <Box sx={{ padding: "16px", borderBottom: "5px solid #101010", display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
            <h5 style={{ fontSize: "16px", fontWeight: 400, fontFamily: "Poppins", margin: 0, padding: 0 }}>Preview</h5>
            <Switch color="success" onChange={handleToggleChange} />
          </Box>
          {showToggleImage ? (
            <Box sx={{ display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center" }}>
              <img src={toggleImage} width={"175px"} height={"215px"} />
            </Box>
          ) : (
            <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
              {uspMessage.length > 0 && (
                <Box sx={{ width: "100%", pl: "16px", pt: "12px", pr: "32px", pb: "16px", borderBottom: "5px solid #101010" }}>
                  <h6 style={{ margin: 0, padding: 0, fontSize: "14px", fontWeight: 500, fontFamily: "Poppins", color: "#8b8b8b" }}>Product USP</h6>
                  <p style={{ fontSize: "14px", fontWeight: 500, fontFamily: "Poppins", color: "#fff" }}>{uspMessage}</p>
                </Box>
              )}
              {uploadedVideos.length > 0 && (
                <Box sx={{ color: "#fff", px: "16px" }}>
                  <h6 style={{ fontSize: "14px", fontFamily: "Poppins", fontWeight: 500, color: "#8B8B8B" }}>Product Videos</h6>
                  <Box sx={{ width: "full", display: "flex", flexDirection: "column", gap: "10px" }}>
                    {uploadedVideos.map((file, idx) => (
                      <PreviewVideo file={file} key={idx} />
                    ))}
                  </Box>
                </Box>
              )}
              {uploadedImages.length > 0 && (
                <Box sx={{ color: "#fff", px: "16px" }}>
                  <h6 style={{ fontSize: "14px", fontFamily: "Poppins", fontWeight: 500, color: "#8B8B8B" }}>Product Images</h6>
                  <Box sx={{ width: "full", display: "flex", flexDirection: "column", gap: "10px" }}>
                    {uploadedImages.map((file, idx) => (
                      <img key={idx} src={URL.createObjectURL(file)} width="430px" height={"430px"} />
                    ))}
                  </Box>
                </Box>
              )}
            </Box>
          )}
        </Box>
      </Box>

      <MediaUploadModal
        open={openImageModal}
        onClose={() => setOpenImageModal(false)}
        files={modalImages}
        setFiles={setModalImages}
        selectedIndex={selectedImageIndex}
        setSelectedIndex={setSelectedImageIndex}
        accept="image/*"
        title="Add Image (NS-00410)"
        previewLabel="Product Images"
        uploadLabel="Upload Images | Drag & Drop | Browse Files"
        isImage={true}
        onSave={handleSaveImages}
      />

      <MediaUploadModal
        open={openVideoModal}
        onClose={() => setOpenVideoModal(false)}
        files={modalVideos}
        setFiles={setModalVideos}
        selectedIndex={selectedVideoIndex}
        setSelectedIndex={setSelectedVideoIndex}
        accept="video/*"
        title="Add Video (NS-00410)"
        previewLabel="Product Videos"
        uploadLabel="Upload Videos | Drag & Drop | Browse Files"
        isImage={false}
        onSave={handleSaveVideos}
      />
    </Box>
  );
};

export default AddUSPDetails;
